//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Clipboard from 'clipboard';

export default {
  props: ['parentpage', 'acceptName'],
  data() {
    return {
      showNewOrder: false,
      orderUrl: '/order/listbrowser.html',
    };
  },
  computed: {
    wx() {
      return this.$store.state.swx;
    },
    showMiddle() {
      return this.$store.state.showMiddle;
    },
    showTop() {
      return this.$store.state.showTop;
    },
  },

  created() {},
  methods: {
    CopyWechat() {
      var clipboard = new Clipboard('.wxCode');
      clipboard.on('success', (e) => {
        this.$Glb.PlMessage('复制成功', 800, () => {
          window.location.href = 'weixin://';
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on('error', (e) => {
        // 不支持复制
        this.$Glb.PlMessage('该浏览器不支持一键复制,请长按手动复制', 800);
        // 释放内存
        clipboard.destroy();
      });
    },
    toHome() {
      this.$Glb.baiduCount('首页-更多测试');
      window.location.href = `/together/index.html?qd=${this.$Glb.getAttribute().qd}&posId=${this.$Glb.getAttribute().posId}`;
    },
    goMyOrder() {
      window.location = this.orderUrl;
    },
    setWnlBtnType(type) {
      var wnlBtn = document.getElementsByClassName('wnl_history_btn')[0];

      try {
        if (type == 0) {
          wnlBtn.style.cssText = 'display:block !important';
        }
      } catch (error) {}
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/floatmenu.vue